import React from "react";
import RessourcesContainer from "./RessourcesContainer/RessourcesContainer";
import "./Ressources.scss";
import PropTypes from "prop-types";
import NavBarTab from "Components/NavBar/NavBarTab/NavBarTab";
import ProfilBar from "Components/ProfilBar/ProfilBar";

/**
 * Permet d'afficher le composant contenant les ressources
 */
const Ressources = (props) => {
  return (
    <div className="ressources_page">
      <ProfilBar id="mobile" />
      <NavBarTab
        id="desktop"
        select="profil"
        activeIndex={props.activeIndex}
        items={props.items}
      />
      <RessourcesContainer
        items={props.items}
        activeIndex={props.activeIndex}
      />
    </div>
  );
};

Ressources.propTypes = {
  items: PropTypes.array,
  activeIndex: PropTypes.number,
};

export default Ressources;
